import { INVOICE_REVISIT_BY_DAY_COUNTS_UPDATED } from '../constants';

const reducer = (
  state = {
    invoiceRevisitsByDayCounts: [],
  },
  action,
) => {
  switch (action.type) {
    case INVOICE_REVISIT_BY_DAY_COUNTS_UPDATED:
//      console.log(action);
      return {
        ...state,
        invoiceRevisitsByDayCounts: action.invoiceRevisitByDayCounts,
      };

    default:
      return state;
  }
};

export default reducer;
